import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { TAG_PAGE_NAME } from '../../constants/service/app/tagConstants';
import TagListContainer from '../../containers/tag/TagListContainer';

const TagList = () => {
  return (
    <PageTemplate pageName={TAG_PAGE_NAME.TAG_LIST}>
      <TagListContainer />
    </PageTemplate>
  );
};

export default TagList;
